import React from 'react';

export default function Analytics() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Analytics</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            Die Analytics-Funktionalität wird neu aufgebaut.
          </p>
          <div className="text-6xl mb-4">📊</div>
          <p className="text-sm text-gray-500 dark:text-gray-500">Coming Soon...</p>
        </div>
      </div>
    </div>
  );
}
